import { useEffect } from 'react';
import { withRouter } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { Table } from 'ui/table';
import { PaginationFooter } from 'ui/paginationFooter';
import { useClientPaginatedState } from 'ui/table/hooks/useClientPaginatedState';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { InputText } from 'ui/inputs/inputText';
import { PageHeader } from 'ui/pageHeader';
import { selectIsUuidBasedProject } from 'core/userContext';
import { fetchInboundSMSRequest } from '../actions';
import { selectInboundSMSMessages } from '../selectors';
import { configureTableColumns, inboundSmsFilterFn } from '../utils';

export const InboundSMS = () => {
  const inboundSMSMessages = useSelector(selectInboundSMSMessages);
  const isUuidBased = useSelector(selectIsUuidBasedProject);
  const dispatch = useDispatch();

  const {
    currentPage,
    filter,
    itemsPerPage,
    numItems,
    rows,
    setCurrentPage,
    setFilter,
    setItemsPerPage,
    setSortDirection,
    setSortedBy,
    sortDirection,
    sortedBy,
  } = useClientPaginatedState({
    rows: inboundSMSMessages,
    sortedBy: 'createdAt',
    filterFn: inboundSmsFilterFn,
  });

  const COLUMNS = configureTableColumns(isUuidBased);

  useEffect(() => {
    dispatch(fetchInboundSMSRequest());
  }, [dispatch]);

  return (
    <>
      <PageHeader
        pageSubSection="Showing the 250 most recent Inbound SMS messages."
        pageActions={
          <InputText
            data-test="filter-inbound-sms"
            value={filter}
            onChange={setFilter}
            placeholder="Filter messages..."
          />
        }
      >
        Inbound SMS
      </PageHeader>
      <Table>
        <TableHeader
          columns={COLUMNS}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          sortedBy={sortedBy}
          setSortedBy={setSortedBy}
        />
        <TableRows columns={COLUMNS} rows={rows} />
      </Table>
      <PaginationFooter
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        numItems={numItems}
        onUpdate={({ page, pageSize }) => {
          setCurrentPage(page);
          setItemsPerPage(pageSize);
        }}
      />
    </>
  );
};

export default withRouter(InboundSMS);
